<template>
  <app-layout>
    <dialog-modal
        :hideClose="true"
        :show.sync="showReview"
    >
      <template #title>
        <div class="text-2xl font-bold font-black">
          Well done ^.^
        </div>
      </template>
      <template #content>

        <div class="mt-10 flex flex-col justify-center">
          <div class="flex justify-center">
            <label class="font-bold text-2xl">Would you like to give AgileSuite.io a review? </label>
          </div>
        </div>

        <div>
          <div class="mb-5 px-4 py-4 flex justify-center">
            <trustpilot-feedback :topic="route().current()"></trustpilot-feedback>
          </div>
        </div>


      </template>

      <template #footer>
        <button
            @click="showReview=false;"
            type="button"
            class="
                    rounded-full
                    transition
                    duration-200
                    bg-gray-100
                    hover:bg-gray-300
                    focus:outline-none
                    text-black
                    w-full
                    py-2.5
                    rounded-lg
                    text-lg
                    font-semibold
                    text-center
                    inline-block
                  "
        >
          <span class="inline-block mr-2">Maybe later</span>
        </button>
      </template>
    </dialog-modal>


    <div>
      <div class="py-10">
        <div class="flex justify-center py-2 mb-5">
          <div>
           <span class="text-bold text-5xl">
                  {{ this.data.room_name }} - Summary
        </span>
          </div>


          <div>
            <button
                @click="this.$inertia.visit(route('retrospective.accessRoom',{id:this.data.room_key}))"
                class="
            ml-2
              text-xl
                  focus:outline-none
                  text-base
                  mr-2
                  hover:bg-blue-100
                  bg-blue-200

                  text-black
                  py-2
                  px-4
                  font-bold
                  rounded-full
                  shadow-md
                "
            >
              Back to Board
            </button>
          </div>
        </div>

        <a-tooltip>
          <template #title>
            Cards distribution on each column.
          </template>
          <div
              class="flex flex-col mt-4 rounded hover:shadow-2xl transition duration-500 transform hover:scale-105 cursor-pointer"
              :style="getColorBackgroundString(this.data.distribution)">
            <div>


              <div class="px-4 py-4 flex hover:shadow-lg items-center sm:px-6">
                <div class="min-w-0 flex-1 sm:flex sm:items-center sm:justify-between">

                </div>
              </div>
            </div>
          </div>
        </a-tooltip>
        <div class="mt-4 flex flex-row space-x-4 justify-center">
          <a-tooltip :color="column.color" v-for="column in this.data.columns">
            <template #title>
              <div>
                {{ column.subject }}
              </div>
            </template>

            <div
                :class="column.color"
                class="w-4 h-4 rounded-full flex items-center justify-center font-extrabold "
            >
            </div>
          </a-tooltip>
        </div>


        <div class="mx-20 grid grid-cols-1 gap-4 mt-5 md:grid-cols-2  lg:grid-cols-2 ">

          <div>
            <div class="grid grid-cols-1 md:grid-cols-2  lg:grid-cols-2  sm:grid-cols-1">
              <div
                  class="hover:shadow-2xl mr-4 mb-4 transition duration-500 transform hover:scale-105 cursor-pointer bg-gradient-to-r from-green-200 to-blue-200 flex justify-center p-10   rounded-xl space-x-2  shadow-lg">
                <div>
                  <h1 class="flex justify-center text-5xl font-bold text-yellow-500">{{ this.data.average_rate }}<span
                      class="inline-block text-gray-400 text-2xl">/5</span></h1>
                  <span class="text-sm font-bold text-gray-400">Average Rating</span>
                </div>
              </div>
              <div
                  class="hover:shadow-2xl mr-4 mb-4 transition duration-500 transform hover:scale-105 cursor-pointer bg-gradient-to-r from-green-200 to-blue-200 flex justify-center p-10   rounded-xl space-x-2  shadow-lg">
                <div>
                  <h1 class="flex justify-center text-5xl font-bold">{{ this.data.retro_actions }}</h1>
                  <span class="text-sm font-bold text-gray-400">Action(s)</span>
                </div>
              </div>
              <div
                  class="hover:shadow-2xl mr-4 mb-4 transition duration-500 transform hover:scale-105 cursor-pointer bg-gradient-to-r from-green-200 to-blue-200 flex justify-center p-10   rounded-xl space-x-2  shadow-lg">
                <div>
                  <h1 class="flex justify-center text-5xl font-bold">{{ this.data.total_attenders }}</h1>
                  <span class="text-sm font-bold text-gray-400">Participant(s)</span>
                </div>
              </div>
              <div
                  class="hover:shadow-2xl mr-4 mb-4 transition duration-500 transform hover:scale-105 cursor-pointer bg-gradient-to-r from-green-200 to-blue-200 flex justify-center p-10   rounded-xl space-x-2  shadow-lg">
                <div>
                  <h1 class="flex justify-center text-5xl font-bold">{{ this.data.total_cards }}</h1>
                  <span class="text-sm font-bold text-gray-400">Card(s)</span>
                </div>
              </div>
            </div>
          </div>
          <!-- ... -->
          <div>


            <div
                class="hover:shadow-2xl transition duration-500 transform hover:scale-105 cursor-pointer rounded-xl space-x-2  shadow-lg bg-gradient-to-r from-green-200 to-blue-200 py-2 ">
              <div class="mt-10 flex flex-col justify-center">
                <div class="flex justify-center">
                  <label class="font-bold text-2xl">{{ this.data.survey_question }}</label>
                </div>
              </div>

              <div class="mb-1 tracking-wide px-4 py-4">
                <h2 class="text-gray-800 font-bold mt-1">Submits: {{
                    this.data.total_answered
                  }}/{{ this.data.total_attenders }}</h2>
                <div class=" -mx-8 px-8 pb-3">
                  <div class="flex items-center mt-1">
                    <div class=" w-1/5 text-yellow-500 text-bold text-xl tracking-tighter">
                      <span>5 star</span>
                    </div>
                    <div class="w-3/5 ">
                      <div class="bg-gray-200 w-full rounded-lg h-5">
                        <div class="bg-yellow-400 rounded-lg h-5"
                             :style="{width: this.data.five_rate/this.data.total_answered *100 +'%'}"></div>
                      </div>
                    </div>
                    <div class="w-1/5 text-gray-700 pl-3">
                      <span class="text-sm">{{ this.data.five_rate }}</span>
                    </div>
                  </div><!-- first -->
                  <div class="flex items-center mt-1">
                    <div class="w-1/5 text-yellow-500 text-bold text-xl tracking-tighter">
                      <span>4 star</span>
                    </div>
                    <div class="w-3/5">
                      <div class="bg-gray-200 w-full rounded-lg h-5">
                        <div class="bg-yellow-400 rounded-lg h-5"
                             :style="{width: this.data.four_rate/this.data.total_answered *100 +'%'}"></div>
                      </div>
                    </div>
                    <div class="w-1/5 text-gray-700 pl-3">
                      <span class="text-sm">{{ this.data.four_rate }}</span>
                    </div>
                  </div><!-- second -->
                  <div class="flex items-center mt-1">
                    <div class="w-1/5 text-yellow-500 text-bold text-xl tracking-tighter">
                      <span>3 star</span>
                    </div>
                    <div class="w-3/5">
                      <div class="bg-gray-200 w-full rounded-lg h-5">
                        <div class="bg-yellow-400 rounded-lg h-5"
                             :style="{width: this.data.three_rate/this.data.total_answered*100 +'%'}"></div>
                      </div>
                    </div>
                    <div class="w-1/5 text-gray-700 pl-3">
                      <span class="text-sm">{{ this.data.three_rate }}</span>
                    </div>
                  </div><!-- thierd -->
                  <div class="flex items-center mt-1">
                    <div class=" w-1/5 text-yellow-500 text-bold text-xl tracking-tighter">
                      <span>2 star</span>
                    </div>
                    <div class="w-3/5">
                      <div class="bg-gray-200 w-full rounded-lg h-5">
                        <div class="bg-yellow-400 rounded-lg h-5"
                             :style="{width: this.data.two_rate/this.data.total_answered*100 +'%'}"></div>
                      </div>
                    </div>
                    <div class="w-1/5 text-gray-700 pl-3">
                      <span class="text-sm">{{ this.data.two_rate }}</span>
                    </div>
                  </div><!-- 4th -->
                  <div class="flex items-center mt-1">
                    <div class="w-1/5 text-yellow-500 text-bold text-xl tracking-tighter">
                      <span>1 star</span>
                    </div>
                    <div class="w-3/5">
                      <div class="bg-gray-200 w-full rounded-lg h-5">
                        <div class="bg-yellow-400 rounded-lg h-5"
                             :style="{width: this.data.one_rate/this.data.total_answered *100+'%'}"></div>
                      </div>
                    </div>
                    <div class="w-1/5 text-gray-700 pl-3">
                      <span class="text-sm">{{ this.data.one_rate }}</span>
                    </div>
                  </div><!-- 5th -->
                </div>
              </div>

            </div>
          </div>
        </div>

        <div class="h-screen mx-20  mt-5">
          <ActionBoard :roomId="data.room_id" type="room"/>

        </div>

      </div>
    </div>

  </app-layout>


</template>

<script>

import AppLayout from "@/Layouts/AppLayout";
import CreateRetroForm from "@/Pages/Retrospective/CreateRetroForm";
import ExamplePage from "@/Pages/Retrospective/Components/ExamplePage";
import ActionBoard from "@/Pages/Retrospective/ActionBoard/ActionBoard";
import DialogModal from "@/Jetstream/DialogModal";
import TrustpilotFeedback from "@/Components/TrustpilotFeedback";

export default {
  props: ['data'],
  setup() {

    return {}
  },
  data() {
    return {
      isUserLoggedIn: false,
      showReview: false,
    };
  },
  mounted() {
    this.showReview = window.location.href.split('showReview=').pop() === '1';
  },
  methods: {
    getColorBackgroundString(color) {
      return 'background: linear-gradient(to right, ' + color.join(',') + ');';
    },
  },

  components: {
    TrustpilotFeedback,
    DialogModal,
    ActionBoard,
    ExamplePage,
    CreateRetroForm,
    AppLayout,
  },
};
</script>
